module.exports = __webpack_public_path__ + "img/Small-2-Bevel-Attachment-46.742b8af9.png";